<template>
    <div>
        <b-message >
            <b>Expert mode: use at your own risks!</b>
        </b-message>
        <b-button tag="router-link"
                  to="/maps"
                  class="btn-margin"
                  type="is-success">Manage Maps
        </b-button>
        <b-button tag="router-link"
                  to="/tags"
                  class="btn-margin"
                  type="is-outlined">Manage Tags
        </b-button>
        <b-button tag="router-link"
                  to="/packs"
                  class="btn-margin"
                  type="is-success">Manage Packs
        </b-button>
        <b-button tag="router-link"
                  to="/rawActivities"
                  class="btn-margin"
                  type="is-success">Manage Raw activities
        </b-button>
        <b-button tag="router-link"
                  to="/games/createGameInSteps"
                  class="btn-margin"
                  type="is-danger">Create Game (new method)
        </b-button>
    </div>
</template>

<script>
    export default {
        name: "Expert"
    }
</script>

<style scoped>
    .btn-margin {
        margin-left: 10px;
        margin-right: 10px;
    }
</style>


